import React from 'react';
import { withTranslation } from 'react-i18next';
import IcomoonReact from "icomoon-react";
import iconSet from "../../assets/icon-fonts/selection.json";
import styles from './styles.module.sass';

const Icon = ({ style: customStyle = {}, className, description, icon = "", size = "20", color = "#000", title }) => (
    <div style={customStyle} className={`${styles.container} ${styles[className]}`} title={title} >
      <IcomoonReact iconSet={iconSet} icon={icon} size={size} color={color} />
      {description && <div>{description}</div>}
    </div>
  );

export default withTranslation()(Icon);